import React from "react";
import {Tab, Row, Col, Nav} from "react-bootstrap";
// Sections
import TabSection from "./TabSection";

let tabsTitles = [];
let countryOb;
let activeTab = "";
let tabsNav = [];
let tabsContent = [];
let countryName1 = "";

class TabsContainer extends React.Component {
  constructor(props) {
    super(props);

    // Store Country Json
    const countryJson = this.props.countryJson;
    //Find country tabs
    for (const countryName in countryJson) {
      if (countryJson.hasOwnProperty(countryName)) {
        countryName1 = countryName;
        // Reset all store data to be empty and reload it with new data
        tabsContent = [];
        tabsNav = [];
        countryOb = countryJson[countryName];
        console.log("countryOb", countryOb);
        tabsTitles = Object.keys(countryOb);
        console.log("tabsTitles", tabsTitles);
      }
    }

    // Reset all collected data and render the new country data
    activeTab = "";
    // content = [];
    activeTab = tabsTitles[0];
    console.log(tabsTitles);
    // Render Tabs names and their content
    tabsTitles.forEach((tab) => {
      tabsNav.push(
        <Nav.Item key={Math.random()}>
          <Nav.Link eventKey={tab}>{tab}</Nav.Link>
        </Nav.Item>
      );

      tabsContent.push(
        <Tab.Pane key={Math.random()} eventKey={tab}>
          <div>
            <TabSection
              title={null}
              text={countryOb[tab]}
              key={Math.random()}
              countryName={countryName1}
            />
          </div>
        </Tab.Pane>
      );
      console.log(tabsContent);
    });
  }
  render() {
    return (
      <>
        <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab}>
          <Row className="mb-4">
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                {tabsNav}
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>{tabsContent}</Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </>
    );
  }
}

export default TabsContainer;
